import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import ReportByPublisher from "../../pages/reportByPublisher";
import IndicatorsByPublisher from "../../pages/indicatorsByPublisher";
import { PlacementsByPublisher } from "../../pages/placementsByPublisher";
import ReportPayments from "../../pages/payment/adm/reportPayments";
import AnalyticsIntegration from "../../pages/analyticsIntegration/analyticsIntegration";
import { LayoutTypes } from "../../pages/layoutTypes/actions/list";
import { LayoutDefinition } from "../../pages/layoutDefinitions/actions/list";
import { Push } from "../../pages/pushNotifications/actions/list";
import { Sites } from "../../pages/sites/actions/list";
import { Users } from "../../pages/users/actions/list";
import { Networks } from "../../pages/networks/actions/list";
import { BlackListURLs } from "../../pages/blackList/actions/list";
import { Domains } from "../../pages/adunits/domains/actions/list";

// context
import { useLayoutState } from "../../context/LayoutContext";

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/pushNotifications" component={Push} />
            <Route path="/reportByPublisher" component={ReportByPublisher} />
            <Route
              path="/indicatorsByPublisher"
              component={IndicatorsByPublisher}
            />
            <Route
              path="/placementsByPublisher"
              component={PlacementsByPublisher}
            />
            <Route path="/reportPayments" component={ReportPayments} />
            <Route path="/layoutTypes" component={LayoutTypes} />
            <Route path="/layoutDefinition" component={LayoutDefinition} />
            <Route path="/sites" component={Sites} />
            <Route path="/users" component={Users} />
            <Route path="/networks" component={Networks} />
            <Route path="/blackList" component={BlackListURLs} />
            <Route path="/adunits" component={Domains} />
            <Route
              path="/analyticsIntegration"
              component={AnalyticsIntegration}
            />
          </Switch>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
